/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: gaoyuanyuan
 * @LastEditTime: 2026-04-08 14:19:14
 */
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: 'Interpretacja raportu AI',
        train: 'Plan treningowy',
        loading: 'Ładowanie, proszę czekać... ',
        loadingError1: 'Nie udało się załadować raportu',
        loadingError2: 'Przepraszamy za utrudnienia, spróbuj ponownie później',
    },
    // 登录页面
    login: {
        loginAndRegister: 'Zarejestruj się/Zaloguj się',
        registerAndLogin: 'Zaloguj się/Zarejestruj się',
        userLogin: 'Logowanie',
        title: 'Konta zarejestrowane przez numer telefonu i e-mail są oddzielne. Sprawdź typ swojego konta.',
        mobileLogin: 'Telefon',
        emailLogin: 'E-mail',
        email: 'E-mail',
        loginBtn: 'Zaloguj się',
        autoLogin: 'Pozostań zalogowany',
        retransmission: 'ponownie za:{item} s',
        formList: [
            {
                label: 'Wpisz numer telefonu',
                placeholder: 'Pobierz kod',
            },
            {
                label: 'Kod weryfikacyjny',
                placeholder: 'Syötä koodi ',
            },
            {
                label: 'Wpisz adres e-mail',
            },
        ],
        btn: {
            submit: 'Utwórz nowe konto',
            title: 'Podanie prawdziwych danych jest kluczowe, wypełnij uważnie.',
        },
        rule: {
            phone: {
                requiredMsg: 'Nieprawidłowy format numeru telefonu',
                patternMsg: 'Numer telefonu nie jest zarejestrowany. Utwórz nowe konto.',
            },
            authCode: {
                requiredMsg: 'Błędny kod weryfikacyjny, wpisz ponownie',
            },
            email: {
                requiredMsg: 'Nieprawidłowy format e-mail',
                patternMsg: 'E-mail nie jest zarejestrowany. Utwórz nowe konto.',
            },
        },
        codeSuccess: 'Kod weryfikacyjny został wysłany. Sprawdź wiadomość.',
        success: 'Wysłano pomyślnie',
        error: 'Błąd wysyłania',
        loginSuccess: 'Zalogowano pomyślnie',
        account: {
            accountTitle: 'Zaloguj się',
            registerTitle: 'Zarejestruj się',
            resetTitle: 'Ustaw hasło',
            password: 'Hasło',
            placeholder: 'Wpisz hasło',
            codeLogin: 'Zaloguj kodem weryfikacyjnym',
            accountLogin: 'Zaloguj kodem weryfikacyjnym',
            forgotPassword: 'Nie pamiętasz hasła?',
            registerTips: ['Nie masz konta?', 'Zarejestruj się', 'Konto już istnieje', 'Zarejestruj się teraz'],
            checkRule: [
                ' 8-20 znaków',
                'Przynajmniej jedna wielka litera',
                'Przynajmniej jedna mała litera',
                'Przynajmniej jedna cyfra',
                'Hasła nie są identyczne',
            ],
            errorTips: ['Błędne hasło', 'Logowanie nie powiodło się', 'Konto nie istnieje'],
            reset: [
                'Zresetuj hasło',
                'Dalej',
                'Nowe hasło nie może być takie samo jak poprzednie',
                'Pomiń',
                'Hasło ustawione pomyślnie',
            ],
            setPasswordTips: 'Hasło musi mieć 8-20 znaków, zawierać wielkie i małe litery oraz cyfry.',
            confirmPassword: 'Potwierdź hasło',
        },
        switchButton: 'Logowanie hasłem',
        switchButton1: 'Zaloguj kodem weryfikacyjnym',
        loginTips: 'Niezarejestrowane konto zostanie automatycznie utworzone po pomyślnym zalogowaniu',
        otherLogin: 'Inne metody logowania',
        newEmailLogin: 'Logowanie przez e-mail',
        newPhoneLogin: 'Logowanie numerem telefonu',
        bindLineTips: 'lub',
        bindEmail: 'Połącz z logowaniem przez e-mail',
        bindPhone: 'Połącz z logowaniem przez numer telefonu',
        bindAndContinue: 'Powiąż i kontynuuj',
        bind: 'Powiąż',
        bindEmailTitle: 'Powiąż e-mail',
        bindEmailTips1: 'Nie znaleziono e-maila {item} ',
        bindEmailTips2: 'Powiąż e-mail, aby kontynuować',
        bindEmailTips3: 'Brak powiązanego e-maila. Umożliwia logowanie i reset hasła.',
        boundTitle: 'Masz już konto?',
        boundCenterTitle1: 'Jeśli jesteś nowym użytkownikiem',
        boundCenterTips1: 'Utwórz konto, aby zacząć',
        boundCenterTitle2: 'Jeśli masz już konto',
        boundCenterTips2: 'Powiąż konto, aby zsynchronizować dane',
        boundCenterTips3: 'Proszę powiązać z zarejestrowanym kontem',
        boundCenterTips4: 'Polecane',
        boundCenterTips5: 'Powiąż {item} z istniejącym kontem',
        boundCenterTips6: 'Dane i raporty zostaną zsynchronizowane',
        boundButton1: 'Utwórz konto przez {item}',
        boundButton2: 'Powiąż istniejące konto',
        phoneCode: 'Kod SMS',
        phonePassword: 'Telefon i hasło',
        emailCode: 'Kod e-mail',
        emailPassword: 'E-mail i hasło',
        accountDoesNotExist:
            'To konto nie jest jeszcze zarejestrowane. Zakończ rejestrację, używając kodu weryfikacyjnego e-mail lub przez Google/Facebook.',
        toRegister: 'Zarejestruj się',
        bindNow: 'Połącz teraz',
        bindError: [
            'Powiązanie nie powiodło się',
            'Rozłączono pomyślnie',
            'Powiązanie nie powiodło się',
            'Autoryzacja nie powiodła się',
            'Błąd autoryzacji, nie można pobrać informacji o koncie',
            'Powiązano pomyślnie',
            'Konto nie istnieje, powiąż z zarejestrowanym kontem',
            'Błąd powiązania, to konto jest już połączone z {item}',
            'Konto zarejestrowane przez autoryzację, rozłączenie niemożliwe',
            'Konto nie istnieje. Zaloguj się kodem weryfikacyjnym, aby się zarejestrować',
        ],
        accountSecurity: {
            faceBook: 'Konto Facebook',
            google: 'Konto Google',
            isBind: 'Niepowiązane',
            dialogTitle: 'Czy na pewno rozłączyć?',
            dialogCenter: ' Po rozłączeniu {item} logowanie za jego pomocą będzie niemożliwe.',
            bindFailure: 'Rozłączenie nie powiodło się',
            bindFailureTips:
                'Twoje konto {item} jest już powiązane z poniższym kontem. Aby zmienić powiązanie, zaloguj się na poniższe konto i rozłącz je.',
            returnButton: 'Potwierdź i wróć',
        },
        bindEmailError: ['E-mail już istnieje. Użyj innego.'],
    },
    // 注册页面
    register: {
        mobileRegister: 'Rejestracja przez telefon',
        emailRegister: 'Rejestracja przez e-mail',
        enroll: 'Numer telefonu jest już zarejestrowany',
        enrollEmail: 'Rejestracja przez e-mail',
        search: 'Szukaj',
        title: 'Konta zarejestrowane przez numer telefonu i e-mail są oddzielne. Sprawdź typ swojego konta.',
        needRead: {
            agree: 'Przeczytałem(-am) i akceptuję',
            privacy: '„Polityka Prywatności”',
        },
        register: 'Zarejestruj się',
        check: 'Zaznacz „Politykę Prywatności”',
        newUser: 'Rejestracja nowego użytkownika',
        form: {
            labelList: ['Imię i nazwisko', '* Płeć', '* Wzrost', '* Wiek'],
        },
        placeholder: ['Wpisz imię i nazwisko', 'Wpisz swój wzrost', 'Wpisz swój wiek'],
        unit: ['System metryczny', 'System imperialny', 'lat(a)'],
        sexOptions: {
            male: 'Mężczyzna',
            female: 'Kobieta',
        },
        btn: 'Wyślij',
        rules: {
            metricheight: ['Dozwolony zakres wzrostu: 2ft 3in - 6ft 7in. Wpisz ponownie.'],
            heightMsg: ['Dozwolony zakres wzrostu: 70-200 cm. Wpisz ponownie.'],
            ageMsg: ['Dozwolony zakres wieku: 10-99 lat. Wpisz ponownie.'],
            agePointMsg: ['Wiek musi być liczbą całkowitą. Wpisz poprawny wiek.'],
        },
        success: 'Rejestracja zakończona sukcesem',
        userMessage: 'Wpisz nazwę użytkownika',
        verify: 'Wpisz 4-cyfrowy kod weryfikacyjny',
        errorMsg: 'Format wzrostu nie obsługuje liczb dziesiętnych. Wpisz ponownie.',
        abnormalMsg: 'Błąd rejestracji',
    },
    // 模型合成
    model: {
        loading: 'Generowanie modelu, proszę czekać...',
        modelLoading: 'Ładowanie modelu...',
        tabPane: [
            {
                title: 'Technologia precyzyjnego skanowania 3D',
                msg: 'Precyzyjne skanowanie 3D rejestruje detale ciała, zapewniając milimetrową dokładność pomiaru obwodów i wizualizację efektów treningowych.',
            },
            {
                title: 'Algorytm składu ciała BDA',
                msg: 'Visbody wykorzystuje zaawansowany system BDA (Body Volume Analysis) do precyzyjnej oceny składu ciała i ryzyka zdrowotnego związanego z otyłością.',
            },
            {
                title: 'Czynniki wpływające na dokładność',
                msg: 'Luźna odzież lub przedmioty przy ciele mogą wpływać na wynik. Aby uzyskać precyzyjne dane, załóż obcisły strój lub ogranicz ilość odzieży.',
            },
            {
                title: 'Dostęp do raportu',
                msg: 'Dodaj stronę do zakładek, aby łatwo wrócić do raportu. Możesz też wysłać raport na swój e-mail.',
            },
        ],
        collect: ['Dodaj tę stronę do ulubionych,', 'aby łatwo przeglądać raporty w przyszłości.'],
        know: 'Norma',
        reminder: [
            'Wskazówka',
            'Twój model 3D jest gotowy. Przesuń w lewo lub w prawo, aby go obrócić.',
            'Raport został wygenerowany. Kliknij „Wyświetl raport”, aby go zobaczyć.',
            'Ocena postawy nie powiodła się. Sprawdź raport składu ciała.',
            'Analiza składu ciała nie powiodła się. Sprawdź raport oceny postawy.',
            'Pomiar nie powiódł się. Spróbuj ponownie przy urządzeniu.',
            'Analiza składu ciała nie powiodła się. Spróbuj ponownie przy urządzeniu.',
            'Ocena postawy nie powiodła się. Spróbuj ponownie przy urządzeniu.',
        ],
        btn: {
            viewReport: 'Wyświetl raport',
            bodyReport: 'Wyświetl raport składu ciała',
            postureReport: 'Wyświetl raport postawy',
            lastReport: 'Wyświetl poprzedni raport',
            loading: 'Ładowanie...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Pobierz raport',
            send: 'Wyślij raport',
            report: 'Raport',
        },
        reportSuccess: 'Raport wygenerowany pomyślnie',
        tabPane: {
            labelList: ['Czas pomiaru', 'Parametry pomiarowe', 'Skład ciała', 'Ocena postawy', 'Funkcja barków'],
        },
        sendEmail: 'Wyślij na e-mail:',
        requiredMsg: 'Wpisz swój adres e-mail',
        patternMsg: 'Wpisz poprawny adres e-mail',
        send: 'Wyślij',
        download: 'Pobierz raport',
        sendReport: 'Wyślij raport',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Zmieniono płeć pomyślnie',
            height: 'Zmieniono wzrost pomyślnie',
            age: 'Zmieniono wiek pomyślnie',
        },
        logOut: 'Wyloguj się',
        personal: 'Profil użytkownika',
        cut: 'Zmień jednostki / język',
        changeSort: 'Przełącz raport produktu',
        setPassword: 'Ustaw / Zmień hasło',
        accountSecurity: 'Konto i bezpieczeństwo',
        describe: '* Po zmianie modelu produktu zostaną wyświetlone wszystkie raporty pomiarowe dla tego modelu.',
        describeBtn: 'Po zmianie modelu nastąpi przekierowanie do najnowszego raportu dla tego urządzenia.',
        descReport: 'Pomyślnie przełączono raport produktu',
        unit: ['System metryczny (kg, cm)', 'System imperialny (ft, in, lb)'],
        read: {
            reading: 'Przeczytaj',
            privacy: '„Polityka Prywatności”',
        },
        setting: 'Ustawienia',
        form: {
            labelList: ['Numer telefonu', 'Jednostki', 'Język', 'Pseudonim', 'Płeć', 'Wzrost', 'Wiek'],
        },
        placeholder: ['Edytuj pseudonim', 'Zmiana płci', 'Zmiana wzrostu', 'Zmiana wieku'],
        btn: {
            cancelBtn: 'Anuluj',
            accomplishBtn: 'Gotowe',
            confirmBtn: 'Zatwierdź',
        },
        dialog: [
            'Płeć jest kluczowym czynnikiem analizy składu ciała. Zmiana wpłynie na spójność z poprzednimi danymi. Czy na pewno chcesz zmienić?',
            'Wzrost jest kluczowym czynnikiem analizy składu ciała. Zmiana wpłynie na spójność z poprzednimi danymi. Czy na pewno chcesz zmienić?',
            'Wiek jest kluczowym czynnikiem analizy składu ciała. Zmiana wpłynie na spójność z poprzednimi danymi. Czy na pewno chcesz zmienić?',
        ],
        rules: {
            metricheight: ['Wpisz wzrost w zakresie (2ft 3in - 6ft 7in)'],
            heightMsg: ['Wpisz wzrost w zakresie (70-200 cm)'],
            ageMsg: ['Wpisz wzrost w zakresie (70-200 cm)', 'Wiek musi być liczbą całkowitą. Wpisz poprawny wiek.'],
        },
        heightMsg: 'Wybierz wzrost ponownie',
        ageMsg: 'Wybierz wiek ponownie',
        ModelBinding: 'Kod został już zeskanowany przez innego użytkownika. Wykonaj pomiar ponownie.',
        ReportEmpty: {
            title: 'Brak dostępnych raportów pomiarowych',
            desc: 'Znajdź skaner Visbody 3D i wykonaj swój pierwszy pomiar!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Kod został już zeskanowany przez innego użytkownika. Wykonaj pomiar ponownie.',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Brak dostępnych raportów pomiarowych',
        desc: 'Brak dostępnych raportów pomiarowych',
        descS30: 'Znajdź skaner Visbody 3D i wykonaj swój pierwszy pomiar!',
        descM30: 'Znajdź skaner Visbody 3D i wykonaj swój pierwszy pomiar!',
    },
    // 用户信息
    userInfo: {
        height: 'Wzrost:',
        age: 'Wiek:',
        unit: 'lat(a)',
        weight: 'Masa ciała',
    },
    // 体成分
    mass: {
        title: 'Przegląd oceny składu ciała',
        titles: 'Skład ciała',
        springFrame: '',
        massFrame: 'Brak danych pomiarowych na dziś',
        contrast: 'Wybierz raport do porównania',
        contrastReport: 'Wybierz raport porównawczy',
        noRecord: 'Brak zapisu',
        score: 'pkt',
        status: 'Twój obecny stan składu ciała',
        WT: 'Masa ciała',
        PBF: 'Procentowa zawartość tłuszczu    (PBF)',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Wartość zmierzona',
            standardRange: 'Zakres normy',
            comparedWithLastLime: 'Porównanie z poprzednim',
            comparedNet: 'Porównanie z poprzednim',
            current: 'Wynik obecnego pomiaru',
            WT: 'Masa ciała',
            FFM: 'Beztłuszczowa masa ciała (FFM)',
            BFM: 'Tkanka tłuszczowa',
            LM: 'Masa mięśniowa',
            TBW: 'Całkowita zawartość wody (TBW)',
            SM: 'Mięśnie szkieletowe (SMM)',
            PROTEIN: 'Białko',
            TM: 'Minerały',
            BMR: 'Podstawowa przemiana materii (BMR)',
            WHR: 'Stosunek talii do bioder (WHR)',
            BMI: 'BMI',
            PBF: 'Procentowa zawartość tłuszczu (PBF)',
            VFG: 'Poziom tłuszczu trzewnego',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        // 定义解读
        explain: [
            {
                title: 'Masa ciała',
                msg: 'Masa ciała to suma całkowitej zawartości wody, białka, minerałów i tkanki tłuszczowej.',
            },
            {
                title: 'Beztłuszczowa masa ciała (FFM)',
                msg: 'Beztłuszczowa masa ciała to masa organizmu po odjęciu tkanki tłuszczowej.',
            },
            {
                title: 'Tkanka tłuszczowa',
                msg: 'Tkanka tłuszczowa to suma tłuszczu podskórnego, trzewnego oraz tłuszczu między-mięśniowego.',
            },
            {
                title: 'Masa mięśniowa',
                msg: 'Masa mięśniowa obejmuje tkankę chudą organizmu, w tym mięśnie szkieletowe, gładkie i mięsień sercowy.',
            },
            {
                title: 'Całkowita zawartość wody (TBW)',
                msg: 'Woda stanowi największy składnik ciała (50%-70% masy). Jest obecna w komórkach i płynach ustrojowych, głównie w tkance mięśniowej.',
            },
            {
                title: 'Mięśnie szkieletowe (SMM)',
                msg: 'Mięśnie szkieletowe (poprzecznie prążkowane) są przytwierdzone do kości. Ta wartość określa ich całkowitą zawartość.',
            },
            {
                title: 'Białko',
                msg: 'Białko to stała substancja zawierająca azot, obecna we wszystkich komórkach. Jest głównym budulcem mięśni.',
            },
            {
                title: 'Minerały',
                msg: 'Ciało składa się z materii organicznej, nieorganicznej i wody. Składniki nieorganiczne (minerały) stanowią ok. 5% masy ciała.',
            },
            {
                title: 'Podstawowa przemiana materii (BMR)',
                msg: 'BMR to energia zużywana przez organizm w ciągu doby w stanie spoczynku, bez uwzględnienia aktywności czy trawienia.',
            },
            {
                title: 'Stosunek talii do bioder (WHR)',
                msg: 'WHR to stosunek obwodu talii do obwodu bioder, kluczowy wskaźnik otyłości brzusznej.',
            },
            {
                title: 'BMI',
                msg: 'BMI służy do oceny ogólnej masy ciała i jest międzynarodowym standardem określającym stopień niedowagi lub nadwagi.',
            },
            {
                title: 'Procentowa zawartość tłuszczu (PBF)',
                msg: 'Procentowa zawartość tłuszczu to stosunek masy tkanki tłuszczowej do całkowitej masy ciała.',
            },
            {
                title: 'Poziom tłuszczu trzewnego',
                msg: 'Poziom tłuszczu trzewnego jest kluczowym wskaźnikiem pozwalającym ocenić występowanie otyłości ukrytej.',
            },
            {
                title: 'Płyn wewnątrzkomórkowy (ICF)',
                msg: 'Płyn wewnątrzkomórkowy (ICF): To całkowita objętość płynów zawartych w komórkach organizmu, stanowiąca podstawowy składnik protoplazmy.',
            },
            {
                title: 'Płyn zewnątrzkomórkowy (ECF)',
                msg: 'Płyn zewnątrzkomórkowy (ECF): To płyny znajdujące się poza komórkami, obejmujące osocze oraz płyn śródmiąższowy (między naczyniami krwionośnymi a komórkami tkanek).',
            },
            {
                title: 'Wiek metaboliczny',
                msg: 'Wiek metaboliczny odzwierciedla wydolność funkcji metabolicznych organizmu',
            },
            {
                title: 'Wskaźnik płynu pozakomórkowego',
                msg: 'Wskaźnik ECW to stosunek płynu pozakomórkowego (ECW) do całkowitej zawartości wody в organizmie (TBW). Powszechnie nazywany wskaźnikiem obrzęku, jest kluczowym parametrem służącym do oceny równowagi płynów w organizmie.',
            },
        ],
        // 节段
        segment: {
            fat: 'Tłuszcz segmentowy',
            muscle: 'Mięśnie segmentowe',
            right: 'Prawa',
            left: 'Lewa',
            standard: 'Norma',
            lowStandard: 'Poniżej normy',
            superStandard: 'Powyżej normy',
            peel: '(Tara)',
        },
    },
    // 体态
    shape: {
        title: 'Przegląd oceny postawy',
        titles: 'Postawa',
        status: 'Twój obecny stan postawy',
        suggest: 'Zalecenia',
        possibility: ', występuje',
        models: {
            front: 'Przód',
            left: 'Lewy bok',
            right: 'Prawy bok',
            top: 'Tył',
            low: 'Niski',
            high: 'Wysoki',
            normal: 'Norma',
        },
        item: {
            deviate: 'Wartość zmierzona',
            result: 'Opis',
            normal: 'Norma',
            abnormal: 'Nieprawidłowość',
            keAbnormal: 'Możliwa nieprawidłowość',
            head: 'Wysunięcie głowy do przodu',
            headSlant: 'Przechylenie głowy na bok',
            roundShoulderLeft: 'Lewy bark wysunięty (zaokrąglony)',
            roundShoulderRight: 'Prawy bark wysunięty (zaokrąglony)',
            highLowShoudler: 'Nierówne barki',
            pelvis: 'Przesunięcie miednicy przód/tył',
            leftKneeCheck: 'Ocena lewego kolana',
            rightKneeCheck: 'Ocena prawego kolana',
            leg: 'Typ nóg',
            leftLeg: 'Lewa noga:',
            rightLeg: 'Prawa noga:',
        },
        // 定义解读
        explain: [
            {
                title: 'Wysunięcie głowy do przodu',
                msg: 'Kąt między linią łączącą lewy punkt uszny i środek szyi a boczną linią środkową',
            },
            {
                title: 'Przechylenie głowy na bok',
                msg: 'Kąt między linią łączącą środek głowy i środek szyi a przednią linią środkową',
            },
            {
                title: 'Lewy bark wysunięty (zaokrąglony)',
                msg: 'Kąt między linią najwyższego punktu lewej strony pleców a styczną barku',
            },
            {
                title: 'Prawy bark wysunięty (zaokrąglony)',
                msg: 'Kąt między linią najwyższego punktu prawej strony pleców a styczną barku',
            },
            {
                title: 'Nierówne barki',
                msg: 'Pionowa odległość między lewym i prawym wyrostkiem barkowym (widok z tyłu)',
            },
            {
                title: 'Przesunięcie miednicy przód/tył',
                msg: 'Kąt utworzony przez środek szyi, punkt biodrowy i kostkę (lewy bok)',
            },
            {
                title: 'Kąt utworzony przez środek szyi, punkt biodrowy i kostkę (lewy bok)',
                msg: 'Kąt utworzony przez punkt biodrowy, staw kolanowy i kostkę (lewy bok)',
            },
            {
                title: 'Ocena prawego kolana',
                msg: 'Kąt utworzony przez punkt biodrowy, staw kolanowy i kostkę (prawy bok)',
            },
            {
                title: 'Typ nóg',
                msg: 'Kąt utworzony przez punkt biodrowy, staw kolanowy i kostkę (widok z przodu)',
            },
            {
                title: 'Przodopochylenie / tyłopochylenie miednicy',
                msg: 'Kąt między pionem a płaszczyzną trójkąta utworzonego przez kolce biodrowe przednie górne i spojenie łonowe',
            },
            {
                title: 'Nierówność długości kończyn dolnych',
                msg: 'Różnica wysokości fałdów pośladkowych mierzona od podłoża (widok z tyłu)',
            },
        ],
        exception: [
            {
                title: 'Odchylenie w lewo',
                abnormal: '',
            },
            {
                title: 'Odchylenie w prawo',
                abnormal: '',
            },
            {
                title: 'Lewa strona wyżej',
                abnormal: '',
            },
            {
                title: 'Prawa strona wyżej',
                abnormal: '',
            },
            {
                title: 'Przesunięcie miednicy w tył',
                abnormal: '',
            },
            {
                title: 'Przesunięcie miednicy w przód',
                abnormal: '',
            },
            {
                title: 'Przeprost lewego kolana',
                abnormal: '',
            },
            {
                title: 'Zgięcie lewego kolana',
                abnormal: '',
            },
            {
                title: 'Przeprost prawego kolana',
                abnormal: '',
            },
            {
                title: 'Zgięcie prawego kolana',
                abnormal: '',
            },
            {
                title: 'Nogi typu K',
                abnormal: '',
            },
            {
                title: 'Nogi typu D',
                abnormal: '',
            },
            {
                title: 'Nogi typu X (Koślawość)',
                abnormal: '',
            },
            {
                title: 'Nogi typu O (Szpotawość)',
                abnormal: '',
            },
            {
                title: 'Przodopochylenie miednicy',
                abnormal: '',
            },
            {
                title: 'Tyłopochylenie miednicy',
                abnormal: '',
            },
            {
                title: 'Nieprawidłowość: Lewa noga dłuższa',
                abnormal: '',
            },
            {
                title: 'Nieprawidłowość: Prawa noga dłuższa',
                abnormal: '',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Pionowa odległość między uchem a linią ciężkości ciała',
            },
            {
                msg: 'Kąt między linią łączącą uszy a linią poziomą',
            },
            {
                msg: 'Pionowa odległość lewego wyrostka barkowego od linii ciężkości',
            },
            {
                msg: 'Pionowa odległość prawego wyrostka barkowego od linii ciężkości',
            },
            {
                msg: 'Różnica nachylenia linii szyja-bark po obu stronach',
            },
            {
                msg: 'Pionowa odległość stawu biodrowego od linii ciężkości',
            },
            {
                msg: 'Kąt w płaszczyźnie strzałkowej: kostka, punkt 1 cm poniżej lewego kolana, biodro',
            },
            {
                msg: 'Kąt w płaszczyźnie strzałkowej: kostka, punkt 1 cm poniżej prawego kolana, biodro',
            },
            {
                msg: 'Kąt w płaszczyźnie czołowej: biodra, kolana i kostki (lewa/prawa)',
            },
        ],
        item: {
            pelvis: 'Przesunięcie miednicy w przód',
        },
    },
    // 围度信息
    girth: {
        title: 'Obwód ciała',
        present: '(Obecny)',
        noHistory: 'Brak danych',
        tpl: [
            {
                title: 'Obwód szyi',
                key: 'neckGirth',
            },
            {
                title: 'Obwód lewego ramienia',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Obwód prawego ramienia',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Obwód klatki piersiowej',
                key: 'bustGirth',
            },
            {
                title: 'Obwód talii (wysoki)',
                key: 'waistGirth',
            },
            {
                title: 'Obwód talii (środkowy)',
                key: 'midWaistGirth',
            },
            {
                title: 'Obwód bioder',
                key: 'hipGirth',
            },
            {
                title: 'Obwód lewego uda',
                key: 'leftThighGirth',
            },
            {
                title: 'Obwód lewego uda (środek)',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Obwód lewego uda (min.)',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Obwód prawego uda',
                key: 'rightThighGirth',
            },
            {
                title: 'Obwód prawego uda (środek)',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Obwód prawego uda (min.)',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Obwód lewej łydki',
                key: 'leftCalfGirth',
            },
            {
                title: 'Obwód prawej łydki',
                key: 'rightCalfGirth',
            },
            {
                title: 'Obwód niskiej talii',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Barki',
        model: {
            val: 'Wartość zmierzona',
            scope: 'Zakres normy',
            diff: 'Zmiana',
        },
        normal: 'Norma',
        normalAll: 'Brak istotnych nieprawidłowości w funkcji barków',
        conclusion: 'Wnioski',
        analyse: 'Analiza:: ',
        suggest: 'Zalecenia: ',
        cause: 'W celu ustalenia dokładnych przyczyn skonsultuj się ze specjalistą.',
    },
    reportTips: {
        title: "Czy na pewno chcesz usunąć ten raport? Po usunięciu nie będzie można go odzyskać.",
        confirm: "Usuń",
        success: "Raport został usunięty",
        partial: "Raport został usunięty, część danych nie została zsynchronizowana; prosimy o kontakt z administratorem.",
        failed: "Usuwanie nie powiodło się, spróbuj ponownie później.",
        btnMsg: 'OK',
        alaryTips: 'Ten raport został usunięty przez administratora. Przechodzenie do następnego raportu!',
    },
    saveQr: {
        title: 'Raport pomiaru ciała Visbody 3D',
        btnMsg: 'Przytrzymaj obraz, aby zapisać w telefonie',
        tips: 'Jeśli nie możesz zapisać, przejdź do [Ustawienia] i włącz odpowiednie uprawnienia',
    },
    share: {
        title: 'Skopiuj poniższy link, aby udostępnić',
        btnMsg: 'Kopiuj',
    },
    bodyPrediction: {
        'body-title': 'Prognoza sylwetki',
        'body-yu-ce-status': 'Prognoza na podstawie obecnego stanu',
        'body-setting': 'Ustawienia prognozy sylwetki',
        'body-li-xiang': 'Wartość idealna:',
        'body-ti-zhong': 'Masa ciała',
        'body-ti-zhi-lv': 'Procentowa zawartość tłuszczu (PBF)',
        'body-ji-rou': 'Zawartość mięśni',
        'yu-che-pre': 'Przed prognozą',
        'yu-che-after': 'Po prognozie',
        'zan-model-no': 'Brak modelu',
        'ti-xing-error': 'Generowanie prognozy sylwetki nie powiodło się~',
        'ti-xing-worker-error': 'Prawdopodobnie wystąpił problem z siecią~',
        'ti-xing-adjust': 'Wartość korekty',
        'ji-rou-title': 'Masa mięśniowa',
        'ti-zi-fang': 'Tkanka tłuszczowa',
        'dang-pre-zhi': 'Wartość obecna:',
        'nen-zhang': 'Poziom tłuszczu trzewnego',
        'nen-zhang-title': 'Objaśnienie obszaru tłuszczu trzewnego',
        'nen-zhang-title1':
            'Tłuszcz trzewny gromadzi się między narządami wewnętrznymi i sprzyja otyłości brzusznej. Wskaźnik ten określa powierzchnię przekroju tłuszczu trzewnego.',
    },
    ...zhLocale,
    ...agrEn,
    wifi: {
        title: 'Konfiguracja Wi-Fi',
        tips: 'Wpisz hasło do sieci Wi-Fi',
        password: 'Hasło Wi-Fi',
        'password-placeholder': 'Wpisz hasło Wi-Fi',
        'password-tips': 'Hasło uwzględnia wielkość liter, upewnij się, że jest poprawne',
        button: 'Wygeneruj kod QR',
        'h5-title': 'Konfiguruj dane Wi-Fi',
        'wifi-name': 'Nazwa Wi-Fi:',
        'wifi-password': 'Hasło Wi-Fi:',
        'wifi-qr-tips1': '* Po sprawdzeniu nazwy i hasła Wi-Fi, zeskanuj kod kamerą pod ekranem urządzenia.',
        'wifi-qr-tips2': 'Skieruj kod QR Wi-Fi do kamery pod ekranem, aby zeskanować.',
        'wifi-qr-button': 'Wstecz',
    },
    waist: {
        title: 'Obwód talii i brzucha',
        hou: 'Tył',
        qian: 'Przód',
    },
    yao_wei_1: 'Talia',
    yao_bu_fen_shu: 'Wynik oceny talii',
    waist_fen: 'pkt',
    yao_wei: 'Obwód talii',
    yao_wei_jian_ti_ji: 'Objętość między obwodami talii',
    yao_tun_bi: 'Stosunek talii do bioder (WHR)',
    lun_kuo_fen_xi: 'Analiza sylwetki',
    bei_bu: 'Plecy',
    tunbu: 'Pośladki',
    bei_bu_ti_ji: 'Objętość pleców',
    zheng_chang_fan_wei: 'Zakres normy:',
    shang_ci: 'Poprzednio ',
    ben_ci: 'Obecnie ',
    gupen: {
        zheng_chang: 'Norma',
        qian_qin_yan_chang: 'Nieprawidłowość: Przodopochylenie',
        qian_qin_yi: 'Ryzyko: Przodopochylenia',
        hou_qin_yi: 'Ryzyko: Tyłopochylenia',
        hou_qin_yan_chang: 'Nieprawidłowość: Tyłopochylenie',
        zuo_chang_yan_chang: 'Nieprawidłowość: Lewa noga dłuższa',
        zuo_chang_yi: 'Ryzyko: Lewa noga dłuższa',
        you_chang_yi: 'Ryzyko: Lewa noga dłuższa',
        you_chang_yan_chang: 'Nieprawidłowość: Prawa noga dłuższa',
    },
    gao_yao_xian: 'Obwód talii (wysoki)',
    gao_yao_zhong_xian: 'Linia środkowa wysokiej talii',
    gao_yao_xia_xian: 'Linia dolna wysokiej talii',
    xiao_yao_shang_xian: 'Linia górna niskiej talii',
    xiao_yao_zhong_xian: 'Linia środkowa niskiej talii',
    xiao_yao_xian: 'Obwód niskiej talii',
    qv_jian1: 'Górna sekcja wysokiej talii',
    qv_jian2: 'Dolna sekcja wysokiej talii',
    qv_jian_zhong: 'Środkowa sekcja talii',
    qv_jian3: 'Górna sekcja niskiej talii',
    qv_jian4: 'Dolna sekcja niskiej talii',
    'celiang.failed': 'Pomiar nieudany. Załóż dopasowaną odzież i stój nieruchomo podczas skanowania',
    'jie-gou-yi-chang-ping-gu': 'Ocena nieprawidłowości strukturalnych',
    'teng-tong-feng-xian-ping-gu': 'Ocena ryzyka bólu',
    'zheng-chang': 'Norma',
    'qing-du-yi-chang': 'Lekka nieprawidłowość',
    'zhong-du2-yi-chang': 'Umiarkowana nieprawidłowość',
    'zhong-du-yi-chang': 'Poważna nieprawidłowość',
    'pen-gu-zhuan-xiang-feng-xian-ping-gu': 'Specjalistyczna ocena ryzyka miednicy',
    'qian-qing': 'Przodopochylenie',
    'hou-qing': 'Tyłopochylenie',
    'xuan-zhuan': 'Rotacja',
    'pen-gu-qian-qing-feng-xian-fen-shu': 'Wynik ryzyka przodopochylenia miednicy',
    'pen-gu-hou-qing-feng-xian-fen-shu': 'Wynik ryzyka tyłopochylenia miednicy',
    'pen-gu-xuan-zhuan-feng-xian-fen-shu': 'Wynik ryzyka rotacji miednicy',
    fen: 'pkt',
    'gao-feng-xian': 'Wysokie ryzyko',
    'ji-rou-ping-gu-jie-guo': 'Wyniki oceny mięśni',
    'qian-qing-feng-xian-gao': 'Wysokie ryzyko przodopochylenia',
    'hou-qing-feng-xian-gao': 'Wysokie ryzyko tyłopochylenia',
    'xuan-zhuan-feng-xian-gao': 'Wysokie ryzyko rotacji',
    'qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo':
        'Napięty m. biodrowo-lędźwiowy / dolna cz. m. prostownika grzbietu, osłabiony m. poprzeczny brzucha',
    'gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo':
        'Napięte m. kulszowo-goleniowe, pośladkowe i prostownik grzbietu, osłabiony m. biodrowo-lędźwiowy',
    'dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng':
        'Jednostronne osłabienie m. pośladkowego średniego / nierównowaga m. czworobocznego lędźwi',
    'gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan':
        'Ocena mięśni miednicy w normie. Utrzymuj zdrowe nawyki.',
    'yi-shang-xiang-mu-jun-zheng-chang': 'Wszystkie powyższe parametry w normie',
    'ji-zhu-jie-gou-yi-chang-ping-gu': 'Ocena nieprawidłowości struktury kręgosłupa',
    'zheng-ti-ping-fen': 'Ocena ogólna',
    'jing-zhui': 'Odcinek szyjny',
    'xiong-zhui': 'Odcinek piersiowy',
    'yao-zhui': 'Odcinek lędźwiowy',
    'jing-zhui-jie-gou-yi-chang-ping-fen': 'Wynik nieprawidłowości odcinka szyjnego',
    'xiong-zhui-jie-gou-yi-chang-ping-fen': 'Wynik nieprawidłowości odcinka piersiowego',
    'yao-zhui-jie-gou-yi-chang-ping-fen': 'Wynik nieprawidłowości odcinka lędźwiowego',
    'jing-zhui-ji-rou-ping-gu': 'Ocena mięśni szyi',
    'xiong-zhui-ji-rou-ping-gu': 'Ocena mięśni odcinka piersiowego',
    'yao-zhui-ji-rou-ping-gu': 'Ocena mięśni odcinka lędźwiowego',
    'ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang': 'Ogólne ustawienie kręgosłupa w normie',
    'tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang': 'Postawa głowy i ustawienie kręgów szyjnych w normie',
    "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Wysunięcie/pochylenie głowy z lekkim odchyleniem odcinka C. Uważaj na postawę siedzącą.",
    "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Wysunięcie/pochylenie głowy z odchyleniem odcinka C. Zalecana kontrola postawy i trening.",
    "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Znaczne wysunięcie/pochylenie głowy i odchylenie odcinka C. Zalecana profesjonalna ocena.",
    'xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang':
        'Ustawienie kręgów piersiowych w normie, brak wad strukturalnych',
    "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Lekkie odchylenie odcinka Th. Zaleca się poprawę kontroli postawy.",
    "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Odchylenie odcinka Th wpływa na stabilność. Zalecany trening ukierunkowany.",
    "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Znaczne odchylenie odcinka Th i asymetria. Zalecana profesjonalna korekcja.",
    'yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang':
        'Ustawienie kręgów lędźwiowych w normie, postawa zrównoważona',
    "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Lekkie odchylenie odcinka L, postawa zrównoważona. Zalecana stabilizacja core.",
    "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Odchylenie odcinka L wpływa na stabilność. Zalecany trening korekcyjny.",
    "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Znaczne odchylenie odcinka L. Zalecany profesjonalny plan poprawy.",
    "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Wzmożone napięcie: m. dźwigacz łopatki, MOS, górny czworoboczny. Osłabienie: głębokie zginacze szyi. Zalecana stabilizacja i relaksacja.",
    "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Wzmożone napięcie: lewy MOS i pochyły tylny. Osłabienie: prawy MOS. Zalecany obustronny balans i relaksacja.",
    "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Wzmożone napięcie: prawy MOS. Osłabienie: lewy MOS i pochyły tylny. Zalecana symetryczna stabilizacja i relaksacja.",
    "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Wzmożone napięcie: lewy górny czworoboczny. Osłabienie: środkowy/dolny czworoboczny. Zalecany trening (środek/dół) i relaksacja.",
    "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Wzmożone napięcie: rotatory wewnętrzne i przywodziciele biodra. Osłabienie: m. pośladkowy średni. Zalecany trening pośladków i rozciąganie.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Wzmożone napięcie: m. pośladkowy średni i gruszkowaty. Osłabienie: przywodziciele, rotatory wewn., LCL. Zalecana stabilizacja nóg i relaksacja pośladków.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Wzmożone napięcie: m. pośladkowy średni i gruszkowaty. Jednostronne osłabienie: przywodziciele, rotatory wewn., LCL. Zalecany trening obustronny.",
    'jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong':
        'Zaleca się trening zrównoważony, unikanie przeciążeń jednostronnych.',
    "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Wzmożone napięcie: lewa grupa kulszowo-goleniowa i m. podkolanowy. Osłabienie: czworogłowy i płaszczkowaty. Zalecany trening (czworogłowy/płaszczkowaty) i rozciąganie.",
    "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Wzmożone napięcie: lewy czworogłowy. Osłabienie: m. pośladkowy wielki i grupa kulszowo-goleniowa. Zalecany trening pośladków/taśmy tylnej i rozciąganie.",
    "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Wzmożone napięcie: prawa grupa kulszowo-goleniowa i m. podkolanowy. Osłabienie: czworogłowy i płaszczkowaty. Zalecany trening (czworogłowy/płaszczkowaty) i rozciąganie.",
    "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Wzmożone napięcie: prawy czworogłowy. Osłabienie: m. pośladkowy wielki i grupa kulszowo-goleniowa. Zalecany trening pośladków/taśmy tylnej i rozciąganie.",
    "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Lekkie odchylenie kręgosłupa. Uważaj na postawę i trenuj core.",
    "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Umiarkowane odchylenie kręgosłupa. Zalecany trening pod okiem specjalisty.",
    'ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu':
        'Poważna nieprawidłowość struktury kręgosłupa. Zalecana konsultacja lekarska i ocena wielospecjalistyczna.。',
    'ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan':
        'Ocena mięśni w normie. Utrzymuj zdrowe nawyki.',
    'teng-tong-qian-zai-feng-xian-ping-gu': 'Ocena potencjalnego ryzyka bólu',
    'jing-bu': 'Szyja',
    'bei-bu': 'Plecy',
    'yao-bu': 'Talia',
    'jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen': 'Ocena potencjalnego ryzyka bólu szyi',
    'bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen': 'Ocena potencjalnego ryzyka bólu pleców',
    'yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen': 'Ocena potencjalnego ryzyka bólu lędźwi',
    'di-feng-xian': 'Niskie ryzyko',
    'zhong-feng-xian': 'Średnie ryzyko',
    'ji-zhu-jie-gou-ke-shi-hua': 'Wizualizacja struktury kręgosłupa',
    'tuo-dong-xuan-zhuan-shi-tu': 'Przeciągnij, aby obrócić widok',
    'ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun':
        'Model poglądowy. Ostateczna ocena zależy od profesjonalnej diagnozy.',
    'bei-mian': 'Tył',
    'zheng-shi-tu': 'Widok z przodu',
    'you-shi-tu': 'Widok z prawej',
    'hou-shi-tu': 'Widok z tyłu',
    'zuo-shi-tu': 'Widok z lewej',
    "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Wzmożone napięcie: prawy górny czworoboczny. Osłabienie: środkowy/dolny czworoboczny. Zalecany trening (środek/dół) i relaksacja.",
    'tun-xing': 'Kształt pośladków',
    'dui-bi': 'Porównanie',
    'fang-xing-tun': 'Pośladki kwadratowe ("H")',
    'li-xing-tun': 'Pośladki gruszkowate ("A")',
    'dao-san-jiao-xing-tun': 'Pośladki w kształcie odwróconego trójkąta ("V")',
    'yuan-xing-tun': 'Pośladki okrągłe ("O")',
    'jiao-li-xiang': 'Dość idealny',
    'mi-tao-tun': 'Pośladki w kształcie brzoskwini (Sercowate)',
    'ben-ci': 'Obecnie',
    'li-shi': 'Historia',
    'ben-ci-li-shi': 'Obecnie / Historia',
    'tun-wei': 'Obwód bioder',
    'tun-xing-shuo-ming': 'Opis kształtu pośladków',
    'tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai':
        'Kształt pośladków to krzywizna i forma obszaru między dolną częścią pleców a udami. Ocena tego obszaru pomaga w zarządzaniu sylwetką i zdrowiem.',
    'wo-zhi-dao-le': 'Rozumiem',
    'fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du':
        'Pośladki kwadratowe: wizualnie szerokość na górze i dole jest zbliżona, linie boczne są proste, bez wyraźnych krzywizn.',
    'yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing':
        'Pośladki okrągłe: wizualnie przypominają koło. Tłuszcz jest rozłożony równomiernie, kształt jest pełny i zaokrąglony. Bardzo pożądany typ sylwetki.',
    'li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man':
        'Pośladki gruszkowate: wizualnie węższe u góry, szersze u dołu. Większe nagromadzenie tkanki w dolnej części, brak pełnego kształtu.',
    'dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing':
        'Pośladki w kształcie odwróconego trójkąta: wizualnie szersze u góry, węższe u dołu.',
    'mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing':
        'Pośladki w kształcie brzoskwini: wizualnie przypominają kształt „brzoskwini”. Pełne w dolnej części, z wąską talią. Idealny typ sylwetki.',
    'zan-wu-mo-xing': 'Brak modelu',
    'ce-liang': 'Pomiar',
    'ben-ci-ce-liang': 'Bieżący pomiar',
    'ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang':
        'Synteza bieżącego pomiaru nie powiodła się. Wykonaj pomiar ponownie na urządzeniu.',
    'gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi':
        'Brak modelu dla tej daty. Wybierz inną datę do porównania.',
    'shou-ci-ce-liang-zan-wu-li-shi-shu-ju': 'Pierwszy pomiar, brak danych historycznych',
    'mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia':
        'Ładowanie modelu nie powiodło się. Odśwież stronę i spróbuj ponownie.',
    'jing-zhui-7': 'Kręg szyjny C7',
    'di-gu-zhong-dian': 'Środek kości krzyżowej',
    'di-gu-hou-shang-jiao': 'Tylny górny kąt kości krzyżowej',
    'ren-ti-zhong-xin': 'Środek ciężkości ciała',
    'spine-tips1':
        'Raport służy wyłącznie celom informacyjnym i nie stanowi diagnozy medycznej. Zaleca się konsultację lekarską w celu pełnej oceny.',
    'spine-tips2': ' Specjalistyczny system oceny kręgosłupa Visbody 2025',
    'tun-xing-ping-gu': 'Ocena kształtu pośladków',
    'yi-xia-shi-nin-de-tun-xing-lei-xing': 'Twój typ pośladków:',
    'qi-ta-tun-xing': 'Inne typy pośladków',
    'ji-zhu-ping-gu': 'Ocena kręgosłupa',
    'qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu': 'Specjalistyczna ocena ryzyka kręgosłupa u młodzieży',
    'qing-shao-nian-ji-zhu-fa-yu-zhi-shu': 'Wskaźnik rozwoju kręgosłupa u młodzieży',
    'xue-xi-zi-shi-fu-he-zhi-shu': 'Wskaźnik obciążenia postawą podczas nauki',
    'gu-ge-ping-heng-zhi-shu': 'Wskaźnik równowagi szkieletowej',
    'sheng-chang-qi-teng-tong-yu-jing-zhi-shu': 'Wskaźnik ostrzegawczy bólów wzrostowych',
    'ji-zhu-ce-wan-feng-xian-ping-fen': 'Ocena ryzyka skoliozy',
    'qia-yao-ji-shu-ji-ji': 'Mięsień biodrowo-lędźwiowy / Prostownik grzbietu',
    'xia-bu-jin-zhang-fu-heng-ji-bao-ruo': 'dolna część napięta, m. poprzeczny brzucha osłabiony',
    'ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti':
        'Rozwój kręgosłupa w normie, brak widocznych problemów strukturalnych',
    'cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan':
        'Istnieją niewielkie zagrożenia rozwojowe, zaleca się poprawę nawyków postawy',
    'zhong-du-fa-yu-feng-xian': 'Umiarkowane ryzyko zaburzeń rozwoju',
    'yan-zhong-ying-xiang-ji-zhu-fa-yu': 'Poważny wpływ na rozwój kręgosłupa',
    'xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi':
        'Postawa podczas nauki prawidłowa, możliwa do dłuższego utrzymania',
    'zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi': 'Postawa wymaga poprawy, zalecane przerwy co 45 minut',
    'cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen':
        'Widoczne problemy z postawą, wymagane regularne rozciąganie',
    'xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu':
        'Poważne wady postawy podczas nauki, mogą wpływać na efektywność i rozwój',
    'gu-ge-fa-yu-dui-cheng-zi-shi-wen-ding': 'Rozwój szkieletu symetryczny, postawa stabilna',
    'cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce': 'Występuje lekka asymetria, zalecane monitorowanie',
    'fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi': 'Rozwój nierównomierny, wymagane działania korygujące',
    'gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang': 'Poważna asymetria szkieletu, wpływa na wzrost',
    'zi-shi-liang-hao-teng-tong-feng-xian-di': 'Postawa dobra, niskie ryzyko bólu',
    'qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li': 'Lekkie ryzyko bólu, zalecana korekcja postawy',
    'zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao': 'Umiarkowane ryzyko bólu, wymagana porada specjalisty',
    'gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan': 'Wysokie ryzyko bólu, możliwy odczuwalny dyskomfort',
    'di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan': 'Niskie ryzyko, utrzymuj dobre nawyki postawy',
    'zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu': 'Niskie ryzyko, utrzymuj dobre nawyki postawy',
    'gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu':
        'Wysokie ryzyko, wymagana natychmiastowa ocena medyczna i interwencja',
    'you-liang': 'Doskonały',
    'zhu-yi': 'Uwaga',
    'gan-yu': 'Interwencja',
    'jing-shi': 'Ostrzeżenie',
    'di-fu-he': 'Niskie obciążenie',
    'zhong-fu-he': 'Średnie obciążenie',
    'gao-fu-he': 'Wysokie obciążenie',
    'guo-zai': 'Przeciążenie',
    'ping-heng-xing': 'Bezpieczny',
    'qing-du-bu-ping-heng': 'Lekka nierównowaga',
    'zhong-du-bu-ping-heng': 'Umiarkowana nierównowaga',
    'yan-zhong-bu-ping-heng': 'Poważna nierównowaga',
    'an-quan': 'Bezpieczny',
    'wei-xian': 'Niebezpieczny',
    'wu-yi-chang': 'Brak nieprawidłowości',
    balanceReport: {
        scoreUnit: 'pkt',
        compareLast: 'Porównanie z poprzednim',
        status: {
            excellent: 'Doskonały',
            good: 'Dobry',
            medium: 'Średni',
            fair: 'Przeciętny',
            poor: 'Słaby',
        },
        levelDesc: ['Doskonały', 'Dobry', 'Przeciętny', 'Słaby'],
        systemEvaluation: 'Ocena układu sensorycznego',
        visualEvaluation: 'Ocena sensoryczna wzroku',
        evaluationLevel: 'Ocena (Poziom)',
        unit: 'Jednostki',
        swayRms: 'Stopień kołysania',
        eyeCloseTest: 'Równowaga statyczna z zamkniętymi oczami',
        copArea: ' Obszar trajektorii COP',
        avgSpeed: 'Średnia prędkość',
        maxDisplacement: 'Maksymalne wychylenie',
        centerTrajectory: 'Trajektoria przemieszczenia środka ciężkości',
        eyeOpenTest: 'Równowaga statyczna z otwartymi oczami',
        last: 'Poprzednio ',
        conclusion: {
            eyeClose: {
                level1: 'Twój poziom równowagi statycznej z zamkniętymi oczami jest doskonały (poziom A). Integracja propriocepcji i układu przedsionkowego jest wydajna. Utrzymujesz stabilność bez informacji wzrokowej i poruszasz się swobodnie w warunkach ograniczonej widoczności (np. w nocy).',
                level2: 'Twój poziom równowagi statycznej z zamkniętymi oczami jest dobry (poziom B). Kompensacja proprioceptywna funkcjonuje prawidłowo. Po utracie informacji wzrokowej potrafisz dostosować środek ciężkości; większość czynności wykonujesz poprawnie, wymagając jedynie krótkiej adaptacji.',
                level3: 'Twój poziom równowagi statycznej z zamkniętymi oczami jest przeciętny (Poziom C). Propriocepcja lub funkcja przedsionkowa są osłabione, kołysanie jest większe. W ciemności możesz odczuwać niestabilność lub zawroty głowy; zalecane podparcie.',
                level4: 'Twój poziom równowagi statycznej z zamkniętymi oczami jest słaby (Poziom D). Możliwe zaburzenia układu nerwowego lub propriocepcji. Trudno utrzymać równowagę bez wzroku; ryzyko upadku w ciemności jest znacznie podwyższone.',
            },
            eyeOpen: {
                level1: 'Twój poziom równowagi statycznej z otwartymi oczami jest doskonały (Poziom A). Wysoka wydajność integracji wzrokowo-ruchowej, stabilna postawa i niskie zużycie energii. Doskonała adaptacja w trudnym otoczeniu (nierówny teren, tłum).',
                level2: 'Twój poziom równowagi statycznej z otwartymi oczami jest dobry (Poziom B). Kontrola środka ciężkości opiera się głównie na wzroku przy wsparciu propriocepcji. Codzienne stanie i chodzenie bez trudności, stabilność w prostym otoczeniu wizualnym.',
                level3: 'Twój poziom równowagi statycznej z otwartymi oczami jest przeciętny (Poziom C). Kontrola postawy mniej stabilna, słabsza regulacja wzrokowa. W środowisku z zakłóceniami wizualnymi (ostre światło, ruch) możliwa niestabilność; częste zmiany pozycji przy długim staniu.',
                level4: 'Twój poziom równowagi statycznej z otwartymi oczami jest słaby (Poziom D). Wyraźne kołysanie, słaba kontrola wzrokowa. Możliwe zaburzenia integracji wzrokowo-przedsionkowej. Słaba stabilność w codziennych czynnościach (schody, ulica), podwyższone ryzyko upadku.',
            },
        },
        levelStatus: {
            A: 'Poziom A',
            B: 'Poziom B',
            C: 'Poziom C',
            D: 'Poziom D',
        },
        chart: {
            eyeCloseTest: 'Test stania z zamkniętymi oczami',
            eyeOpenTest: 'Test stania z otwartymi oczami',
            yAxisLabels: ['Niski', 'Średni', 'Wysoki'],
        },
        selectionRport: 'Wybierz raport do porównania',
        measureDes: 'Szczegóły pomiarów',
        balanceTittle: 'Ocena równowagi',
        pingDes: 'Skala ocen: Doskonały, Dobry, Przeciętny, Słaby',
    },
  "neckReport": {
  "title": "Funkcja szyjna",
  "conclusion": "Ocena funkcjonalności szyi",
  "loading": "Trwa generowanie raportu. Proszę czekać.",
  "failed": "Nie udało się wygenerować raportu",
  "analysis": "Analiza",
  "suggestion": "Sugerowanie",
  "suggestionText": "Skonsultuj się z profesjonalistą, aby przeprowadzić dalsze badania i leczenie przyczyn"
}
}
